import type { ReactNode } from "react";

import type { HourlyPeriod } from "../types/dayHourly";
import type { Measurement, WindReading } from "../types/forecast";

import { formatWind } from "./format";

export const GUST_ABS_THRESHOLD = 22;
export const GUST_DELTA = 10;
export const GUST_MIN = 18;

export function windSpeedMph(speed: Measurement): number {
  const unit = speed.unit.toLowerCase();
  if (unit === "kmh" || unit === "km/h") {
    return speed.value / 1.60934;
  }
  return speed.value;
}

export function formatWindChipValue(
  wind: WindReading,
  gustMph: number | null,
  gustNotable: boolean,
): string {
  const base = formatWind(wind.speed, wind.direction);
  if (gustNotable && gustMph !== null) {
    return `${base} (gust ${Math.round(gustMph)})`;
  }
  return base;
}

export function formatWindCell(hour: HourlyPeriod): ReactNode {
  const showGust = hour.gustNotable && hour.gustMph !== null;

  if (!hour.wind) {
    if (showGust) {
      return (
        <span className="text-label-small font-medium text-weather-gust">
          G{Math.round(hour.gustMph!)}
        </span>
      );
    }
    return "—";
  }

  const windText = formatWind(hour.wind.speed, hour.wind.direction);
  if (showGust) {
    return (
      <span className="flex items-center gap-1">
        <span>{windText}</span>
        <span className="text-label-small font-medium text-weather-gust">
          G{Math.round(hour.gustMph!)}
        </span>
      </span>
    );
  }

  return windText;
}
